export default "__VITE_ASSET__BXM5gfhV__"